import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Col, Row, Segmented, Modal } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import useDelete from "../../../global/hooks/useDelete";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";

import {
  CheckCircleOutlined,
  CloseOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
  EditOutlined,
  UnorderedListOutlined,
  InfoCircleOutlined,
  SettingOutlined,
  OrderedListOutlined,
  GiftFilled,
} from "@ant-design/icons";
// import CustomSwitch from "../../../global/components/inputWidgets/CustomSwitch";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import CommonModal from "../../../global/components/CommonModal";
import { LicenseSelectForm } from "./LicenseSelectForm";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import ConfirmModal from "../../../global/components/ConfirmModal";
import DeviceIcon from "../../../assets/images/vectors/SideBarIcons/DeviceIcon";
import LicenseIcon from "./../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import { macValidator } from "../../../global/utils/macValidator";
import { normalizeEmailValue } from "../../../global/utils/normalizeFormEmails";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { DeviceLogItemColumns } from "../Page/DeviceLogItemColumns";
import {
  DeviceOrderItemColumns,
  DeviceOrderItemChildColumns,
} from "../Page/DeviceOrderItemColumns";
import { LuShoppingBag } from "react-icons/lu";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FaCalendarDays } from "react-icons/fa6";
import { hasRole } from "../../../global/hooks/getUserRole";
import {
  calculateDoorPrice,
  calculateLicenseTypePrice,
  calculateSiteTypePrice,
  calculateTotals,
  applyExpiredToOptions,
  enrichGiftCardOptionsWithChannelMobileChildren,
  getCodeValueForGiftCard,
  getItemNoByLabel,
  getPrice,
  inputCardOptions,
  licenseOptions,
  mergeGiftCardItemsState,
  validateGiftCardItemsOldCodeMatchesForm,
  modelIconMap,
  orderTypeOptions,
  productIconMap,
  resolveLicenseTypeFromSiteType,
  siteTypeIconMap,
} from "../../../utils/Common";
import DoorTypeIcon from "../../../assets/images/vectors/DoorTypeIcon";
import OptionCards from "../../../global/components/inputWidgets/OptionCards";
import LicenseConfirmForm from "../../License/Components/LicenseConfirmModal";
import MyPaymentForm from "../../../global/components/PaymentForm";
import { ManageCardsModal } from "../../../global/components/ManageCardsModal";
import {
  AUTOBILLING_CARD_REQUIRED_MESSAGE,
  fetchDealerHasSavedCards,
  normalizeAutoBilling,
} from "../../../global/utils/cardPaymentUtils";
import { getUserRoles } from "../../../global/components/PrivateRoute";
import { useAuthData } from "../../../providers/AuthProvider";
import { GiftCardItemsForm } from "../../MySite/Components/GiftCardItemsForm";
import { LimitedLicenseForm } from "../../MySite/Components/LimitedLicenseForm";
import { LimitedLicenseConfirmForm } from "../../MySite/Components/LimitedLicenseConfirmForm";
import {
  buildLimitedLicenseSummary,
  pickCurrentLimitedOrder,
} from "../../../utils/limitedLicense";

export const DeviceForm = ({ type }) => {
  const { userData } = useAuthData();
  const { isSystemUser, isCustomerUser, isDealerUser, isOemUser } =
    getUserRoles(userData);

  const [showModal, setShowModal] = useState(false);
  const [showCommonModal, setShowCommonModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [OemNo, setOemNo] = useState(null);
  const [dealerNo, setDealerNo] = useState(null);
  const deviceTabs = [
    {
      label: "Device Logs",
      value: "deviceLog",
      icon: <OrderedListOutlined />,
    },
    { label: "Orders", value: "order", icon: <LuShoppingBag /> },
  ];

  const [tabValue, setTabValue] = useState(deviceTabs[0].value);
  const [orderExpandedRowKeys, setOrderExpandedRowKeys] = useState([]);
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [sitetype, setSiteType] = useState(hasRole(7, 8, 9) ? 3 : 0);
  const [nodeType, setNodeType] = useState(null);
  const [licenseSiteType, setLicenseSiteType] = useState(null);
  const [licenseTypePrice, setLicenseTypePrice] = useState(0);
  const [siteTypePrice, setSiteTypePrice] = useState(0);
  const [doorPrice, setDoorPrice] = useState(0);
  const [licenseType, setLicenseType] = useState(0);
  const [licenseOptionsData, setLicenseOptionsData] = useState({});
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [formValuesData, setFormValuesData] = useState(null);
  const [originalLicenseData, setOriginalLicenseData] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [showCardLayout, setShowCardLayout] = useState(!isSystemUser);
  const [pendingUpdatePayload, setPendingUpdatePayload] = useState(null);
  const [pendingSubmitMode, setPendingSubmitMode] = useState(null);
  const [priceChangeAmount, setPriceChangeAmount] = useState(0);
  const [showCardsModal, setShowCardsModal] = useState(false);
  const [cardsModalDealerNo, setCardsModalDealerNo] = useState(null);
  const isPaymentTriggeredApiRef = useRef(false);
  const paymentFlowInProgressRef = useRef(false);
  const [showGiftCardModal, setShowGiftCardModal] = useState(false);
  const [showLimitedLicenseModal, setShowLimitedLicenseModal] = useState(false);
  const [showLimitedLicenseSummary, setShowLimitedLicenseSummary] =
    useState(false);
  const [limitedLicenseSummary, setLimitedLicenseSummary] = useState(null);
  const [limitedApplyDisabled, setLimitedApplyDisabled] = useState(false);
  const giftCardRef = useRef(null);
  const limitedLicenseRef = useRef(null);
  const selectedLimitedCardRef = useRef(null);
  const skipNextDevicePutSuccessRef = useRef(false);
  const pendingGiftCardMarkUsedPayloadRef = useRef(null);
  const giftCardAwaitingPutRef = useRef(false);
  const prevGiftCardPostLoadingRef = useRef(false);

  const giftCardPostUrl = `${process.env.REACT_APP_API_URL}/api/devices/gift-card-items/`;
  const {
    data: giftCardPostData,
    loading: giftCardPostLoading,
    error: giftCardPostError,
    postData: giftCardPostAction,
  } = usePost(giftCardPostUrl);

  const limitedOrderUrl = `${process.env.REACT_APP_API_URL}/api/limited/orders/`;
  const { postData: limitedOrderPostAction } = usePost(limitedOrderUrl);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
    // ProductionNo: null,
  });

  const url = id
    ? `${process.env.REACT_APP_API_URL}/api/devices/${id}/`
    : `${process.env.REACT_APP_API_URL}/api/devices/`;
  // const licenseInfoUrl =
  //   selectedRow.length > 0 && selectedRow[0]?.LicenseNo
  //     ? `${process.env.REACT_APP_API_URL}/api/license/${selectedRow[0].LicenseNo}`
  //     : null;
  const licenseInfoUrl =
    selectedRow[0]?.LicenseNo &&
    `${process.env.REACT_APP_API_URL}/api/licenses/${selectedRow[0]?.LicenseNo}/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  // const postUrl = `${process.env.REACT_APP_API_URL}/api/devices/`;
  // const putUrl = `${process.env.REACT_APP_API_URL}/api/devices/${id}/`;
  // const deleteUrl = `${process.env.REACT_APP_API_URL}/api/devices/${id}/`;
  const { data, loading, error, refetch } = useGet(id ? url : null);
  const { data: individualLicenseData, error: individualLicenseError } =
    useGet(licenseInfoUrl);

  const limitedOrdersPreviewDeviceNo =
    type === "info"
      ? (data?.data?.DeviceNo ?? (id != null && id !== "" ? Number(id) : null))
      : null;
  const limitedOrdersPreviewUrl =
    limitedOrdersPreviewDeviceNo != null &&
    !Number.isNaN(Number(limitedOrdersPreviewDeviceNo))
      ? `${process.env.REACT_APP_API_URL}/api/limited/orders/?DeviceNo=${limitedOrdersPreviewDeviceNo}&limit=20&sort_by=OrderNo&order=desc`
      : null;
  const { data: limitedOrdersPreviewData } = useGet(limitedOrdersPreviewUrl);

  const deviceLogParams = {
    limit: 20,
    sort_by: "LogNo",
    order: "desc",
    DeviceNo: id,
  };
  const deviceLogQuery = new URLSearchParams(deviceLogParams).toString();
  const deviceLogUrl = id
    ? `${process.env.REACT_APP_API_URL}/api/devicelogs/?${deviceLogQuery}`
    : null;
  const {
    data: deviceLogData,
    loading: deviceLogLoading,
    error: deviceLogError,
  } = useGet(deviceLogUrl);

  const licenseOptionUrl = `${process.env.REACT_APP_API_URL}/api/licenses/options/`;
  const { data: licenseOptionData, loading: optionDataLoading } =
    useGet(licenseOptionUrl);
  const modifiedOpLicense = useMemo(
    () =>
      licenseOptionData?.data?.options?.map((entry, index) => {
        return {
          value: `${entry?.value}`,
          label: entry.name,
        };
      }),
    [licenseOptionData],
  );

  const codesUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/codes/?limit=100`;
  const {
    data: codesData,
    loading: codesDataLoading,
    error: codesDataError,
  } = useGet(codesUrl);

  // const deviceLogOrderParams = {
  //   limit: 20,
  //   sort_by: "LogNo",
  //   order: "desc",
  //   DeviceNo: id,
  // };
  // const deviceLogOrderQuery = new URLSearchParams(
  //   deviceLogOrderParams
  // ).toString();
  const deviceLogOrderUrl =
    id && tabValue === "order"
      ? `${process.env.REACT_APP_API_URL}/api/orders/${id}/device-orders/`
      : null;
  const {
    data: deviceLogOrderData,
    loading: deviceLogOrderLoading,
    error: deviceLogOrderError,
  } = useGet(deviceLogOrderUrl);

  const {
    data: optionsData,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);

  const {
    data: postData,
    error: postError,
    postData: postAction,
    loading: postLoading,
  } = usePost(url);
  const {
    data: putData,
    error: putError,
    putData: putAction,
    loading: putLoading,
  } = usePut(url);
  const {
    data: deletedData,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const dealerOptionsUrl =
    OemNo || data?.data?.OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          OemNo
            ? OemNo
            : defaultData?.OemNo
              ? defaultData.OemNo
              : data?.data?.OemNo
        }/dealers/`
      : null;

  const {
    data: dealerOptions,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const custmerOptionsUrl =
    dealerNo || data?.data?.DealerNo || defaultData?.DealerNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${
          dealerNo
            ? dealerNo
            : defaultData?.DealerNo
              ? defaultData.DealerNo
              : data?.data?.DealerNo
        }/customers/`
      : null;

  const {
    data: custmerOptions,
    loading: custmerOptionsLoading,
    error: custmerOptionsError,
    refetch: customerDataRefetch,
  } = useGet(custmerOptionsUrl);

  const modifiedProducts = useMemo(
    () => getModifiedResponse(optionsData, "products"),
    [optionsData],
  );
  const modifiedProductOptions = useMemo(
    () =>
      modifiedProducts.map((product) => ({
        ...product,
        icon: productIconMap[product.value],
        searchLabel: product.label,
      })),
    [modifiedProducts],
  );
  const modifiedModels = useMemo(
    () => getModifiedResponse(optionsData, "models"),
    [optionsData],
  );
  const modifiedModelsOptions = useMemo(
    () =>
      modifiedModels.map((model) => ({
        ...model,
        icon: modelIconMap[model.value],
        searchLabel: model.label,
      })),
    [modifiedModels],
  );

  const modifiedOems = useMemo(
    () => getModifiedResponse(optionsData, "oems"),
    [optionsData],
  );
  // const modifiedProductions = getModifiedResponse(optionsData, "productions");
  // const modifieOp = getModifiedResponse(optionsData, "options");
  const modifiedSiteTypes = useMemo(() => {
    const siteTypes = getModifiedResponse(optionsData, "sitetype");
    if (hasRole(7, 8, 9) && !["edit", "info"].includes(type)) {
      return siteTypes.filter((item) => [3, 4].includes(item.value));
    }
    return siteTypes;
  }, [optionsData, type]);

  const modifiedSiteTypeOptions = useMemo(
    () =>
      modifiedSiteTypes.map((site) => ({
        ...site,
        icon: siteTypeIconMap[site.value],
        searchLabel: site.label,
      })),
    [modifiedSiteTypes],
  );
  const modifiedNodeTypes = useMemo(
    () => getModifiedResponse(optionsData, "nodetype"),
    [optionsData],
  );

  const modifiedDealers = useMemo(
    () => getModifiedResponse(dealerOptions, null),
    [dealerOptions],
  );

  const modifiedCustomers = useMemo(
    () => getModifiedResponse(custmerOptions, null),
    [custmerOptions],
  );

  const resolveEffectiveDealerNo = (formFields = {}) =>
    formFields.DealerNo ??
    (id ? data?.data?.DealerNo : null) ??
    (hasRole(7, 8, 9) ? userData?.dealer_no : null) ??
    dealerNo;

  const getDealerMeta = (dealerNoValue) => {
    if (dealerNoValue == null || dealerNoValue === "") {
      return { billingType: null, discountPercent: 0, autoBilling: null };
    }

    const dealerId = Number(dealerNoValue);
    if (!Number.isFinite(dealerId)) {
      return { billingType: null, discountPercent: 0, autoBilling: null };
    }

    const rawDealers = dealerOptions?.data;
    if (!Array.isArray(rawDealers)) {
      return { billingType: null, discountPercent: 0, autoBilling: null };
    }

    const dealer = rawDealers.find(
      (d) =>
        Number(d?.value) === dealerId ||
        Number(d?.DealerNo) === dealerId ||
        Number(d?.dealer_no) === dealerId,
    );

    const bt =
      dealer?.BillingType ??
      dealer?.billing_type ??
      dealer?.billingType ??
      dealer?.Billing_type ??
      null;
    const billingType =
      bt === null || bt === undefined || !Number.isFinite(Number(bt))
        ? null
        : Number(bt);

    const rawDiscount =
      dealer?.discount ??
      dealer?.Discount ??
      dealer?.discount_percent ??
      dealer?.DiscountPercent ??
      0;
    const parsedDiscount = Number(rawDiscount);
    const discountPercent =
      Number.isFinite(parsedDiscount) && parsedDiscount > 0
        ? Math.min(parsedDiscount, 100)
        : 0;

    const autoBilling = normalizeAutoBilling(
      dealer?.auto_billing ??
        dealer?.AutoBilling ??
        dealer?.autobilling ??
        dealer?.autoBilling,
    );

    return { billingType, discountPercent, autoBilling };
  };

  const applyDealerDiscount = (amount, discountPercent) => {
    const amt = Number(amount);
    if (!Number.isFinite(amt) || amt <= 0) return 0;
    const pct = Number(discountPercent);
    if (!Number.isFinite(pct) || pct <= 0) return Number(amt.toFixed(2));
    return Number((amt * (1 - pct / 100)).toFixed(2));
  };

  const summaryDealerDiscountPercent = (() => {
    const currentFields = form.getFieldsValue(true);
    const effectiveDealerNo = resolveEffectiveDealerNo(currentFields);
    return getDealerMeta(effectiveDealerNo).discountPercent;
  })();

  const modifiedOp = useMemo(
    () =>
      optionsData?.data?.options?.map((entry, index) => {
        return {
          value: `${entry?.value}`,
          label: entry.name,
        };
      }),
    [optionsData],
  );

  const handleDoorChange = (e) => {
    const value = e.target.value;
    const doorCount = Number(value);
    const price = calculateDoorPrice(doorCount, licenseType, codesData);
    setDoorPrice(price);
  };

  const handleModelChange = (value) => {
    const price = calculateLicenseTypePrice(
      value,
      form.getFieldValue("LicenseType"),
      codesData,
      modifiedModelsOptions,
    );
    setLicenseTypePrice(price);
  };

  const handleSiteTypeChange = (value) => {
    const price = calculateSiteTypePrice(
      value,
      form.getFieldValue("LicenseType"),
      codesData,
      modifiedSiteTypeOptions,
    );
    setSiteTypePrice(price);
  };
  useEffect(() => {
    const currentDoorValue = form.getFieldValue("Type");
    if (currentDoorValue) {
      const price = calculateDoorPrice(
        currentDoorValue,
        licenseType,
        codesData,
      );
      setDoorPrice(price);
    }
  }, [licenseType, codesData]);

  useEffect(() => {
    if (hasRole(7, 8, 9)) {
      setOemNo(userData?.oem_no);
      setDealerNo(userData?.dealer_no);
    }
  }, []);

  useEffect(() => {
    if (!paymentModal) setShowCardLayout(!isSystemUser);
  }, [paymentModal, isSystemUser]);

  const handleConfirmSubmit = async () => {
    try {
      const formFields = form.getFieldsValue(true);
      const effectiveDealerNo = resolveEffectiveDealerNo(formFields);
      const hasDealerForPayment =
        effectiveDealerNo != null && effectiveDealerNo !== "";

      // Dealer BillingType gating:
      // - BillingType === 1 => allow "Make Payment" popup when amount increases
      // - BillingType === 0 => skip payment popup and directly save (resume previous behavior)
      const {
        billingType: dealerBillingType,
        discountPercent,
        autoBilling,
      } = getDealerMeta(effectiveDealerNo);

      // AutoBilling + no cards → Payment Method (dealers only; admins lack cards API)
      if (hasDealerForPayment && autoBilling === 1 && !isSystemUser) {
        let hasCards = false;
        try {
          hasCards = await fetchDealerHasSavedCards(effectiveDealerNo);
        } catch {
          hasCards = false;
        }
        if (!hasCards) {
          setCardsModalDealerNo(effectiveDealerNo);
          setShowSummaryModal(false);
          setShowCardsModal(true);
          return;
        }
      }

      const shouldShowPaymentModal =
        hasDealerForPayment &&
        (dealerBillingType == null ? true : dealerBillingType === 1);

      const optionsArray = applyExpiredToOptions(
        Object.entries(licenseOptionsData)
          .filter(
            ([_, val]) => val.type === "toggle" && val.enabled && val.value,
          )
          .map(([_, val]) => Number(val.value)),
        form.getFieldValue("Expired"),
      );

      // Extract field values (quantities) from licenseOptionsData
      const fieldValues = {};
      Object.entries(licenseOptionsData).forEach(([key, val]) => {
        if ((val.type === "input" || val.type === "select") && val.fieldName) {
          // Convert quantity to number for numeric fields
          const quantity = Number(val.quantity);
          fieldValues[val.fieldName] = isNaN(quantity)
            ? val.quantity
            : quantity;
        }
      });

      // Build the final payload
      const payload = {
        ...formValuesData,
        ...fieldValues,
        Options: optionsArray,
        Sicucom:
          fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
            ? Number(fieldValues.Sicucom)
            : 0,
        // Temporary behavior: on edit/update requests always send Facegate as 0.
        Facegate: 0,
        // Mobile Phone card value is saved as Intercom
        Intercom:
          fieldValues.Intercom != null && fieldValues.Intercom !== ""
            ? Number(fieldValues.Intercom)
            : 0,
        Invitation:
          fieldValues.Invitation != null && fieldValues.Invitation !== ""
            ? Number(fieldValues.Invitation) / 100
            : 0,
      };

      const currentTotal = calculateTotals(
        licenseOptionsData,
        licenseTypePrice,
        doorPrice,
        siteTypePrice,
      );

      // Check if editing or creating
      if (id) {
        const originalTotal = originalLicenseData
          ? calculateTotals(
              originalLicenseData.optionsData || {},
              originalLicenseData.licenseTypePrice || 0,
              originalLicenseData.doorPrice || 0,
              originalLicenseData.siteTypePrice || 0,
            )
          : 0;
        const increasedAmount = Number(
          Math.max(currentTotal - originalTotal, 0).toFixed(2),
        );
        const discountedIncreasedAmount = applyDealerDiscount(
          increasedAmount,
          discountPercent,
        );

        if (discountedIncreasedAmount > 0 && shouldShowPaymentModal) {
          setPendingSubmitMode("edit");
          setPendingUpdatePayload(payload);
          setPriceChangeAmount(discountedIncreasedAmount);
          setShowSummaryModal(false);
          setPaymentModal(true);
          return;
        }

        await putAction(payload);
      } else {
        const addAmount = Number(Math.max(currentTotal, 0).toFixed(2));

        if (addAmount > 0 && shouldShowPaymentModal) {
          setPendingSubmitMode("create");
          setPendingUpdatePayload(payload);
          setPriceChangeAmount(addAmount);
          setShowSummaryModal(false);
          setPaymentModal(true);
          return;
        }

        await postAction(payload);
      }

      // Close the modal
      setShowSummaryModal(false);
      setOriginalLicenseData(null);
    } catch (error) {
      console.error("Submission error:", error);
      openErrorNotification(
        id ? "Failed to edit device." : "Failed to create device.",
      );
    }
  };

  const isValidNvrLicenseConfiguration = () => {
    const channel = licenseOptionsData["Channel"];
    const hasMultipleChannels = channel && channel.quantity >= 1;

    if (!hasMultipleChannels) {
      return true; // No validation needed if Channel quantity is 1 or less
    }

    // Check if at least one of the required options is present and enabled
    const requiredOptions = [
      "Vitek NVR",
      "Thumb Drive NVR",
      "Speco NVR",
      "DW Spectrum",
    ];

    const hasRequiredOption = requiredOptions.some((optionName) => {
      const option = licenseOptionsData[optionName];
      return option && option.enabled === true;
    });

    return hasRequiredOption;
  };
  const isValidMobileLicenseConfiguration = () => {
    const mobCred = licenseOptionsData["Mobile Credential"];
    const hasMultipleMobCred = mobCred && mobCred.quantity >= 1;

    if (!hasMultipleMobCred) {
      return true;
    }
    // Check if at least one of the required options is present and enabled
    const requiredOptions = [
      "Sicunet Mobile",
      "Wavelynx Mobile",
      "Farpointe Mobile",
    ];

    const hasRequiredOption = requiredOptions.some((optionName) => {
      const option = licenseOptionsData[optionName];
      return option && option.enabled === true;
    });

    return hasRequiredOption;
  };

  const onFinish = async (values) => {
    try {
      if (values.Email != null) {
        values.Email = normalizeEmailValue(values.Email);
      }
      if (id) {
        if (nodeType === 2 && (isDealerUser || isOemUser)) {
          const modifiedValue = {
            ...values,
            Options: applyExpiredToOptions(
              values?.Options?.map((item) => Number(item)),
              values?.Expired,
            ),
            Type: Number(values.Type),
            NodeType: Number(values.NodeType) || null,
            Channel: values.Channel || 0,
            Lockset: values.Lockset || 0,
            ContLock: values.ContLock || 0,
            // Temporary behavior: on edit/update requests always send Facegate as 0.
            Facegate: 0,
            Subnode: values.Subnode || 0,
            // Mobile Phone card value is saved as Intercom
            Intercom:
              values.Intercom != null && values.Intercom !== ""
                ? Number(values.Intercom)
                : 0,
            Sicucom:
              values.Sicucom != null && values.Sicucom !== ""
                ? Number(values.Sicucom)
                : 0,
            Invitation: values.Invitation ? values.Invitation / 100 : 0,
            DealerNo: values?.DealerNo
              ? values?.DealerNo
              : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
                ? data?.data?.DealerNo
                : null,
            CustomerNo: values?.CustomerNo
              ? values?.CustomerNo
              : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
                ? data?.data?.CustomerNo
                : null,
            OemNo: values?.OemNo
              ? values?.OemNo
              : ![1, 2, 3].includes(userData?.role_value)
                ? data?.data?.OemNo
                : null,
          };
          return await putAction(modifiedValue);
        }

        const optionsArray = applyExpiredToOptions(
          Object.entries(licenseOptionsData)
            .filter(
              ([_, val]) => val.type === "toggle" && val.enabled && val.value,
            )
            .map(([_, val]) => Number(val.value)),
          values?.Expired,
        );

        // Extract field values from optionsData
        const fieldValues = {};
        Object.entries(licenseOptionsData).forEach(([key, val]) => {
          if (
            (val.type === "input" || val.type === "select") &&
            val.fieldName
          ) {
            fieldValues[val.fieldName] = val.quantity;
          }
        });
        const modifiedValue = {
          ...values,
          ...fieldValues,
          Options: optionsArray,
          Type: Number(values.Type),
          NodeType: Number(values.NodeType) || null,
          // Channel: values.Channel || 0,
          // Lockset: values.Lockset || 0,
          // ContLock: values.ContLock || 0,
          // Facegate: values.Facegate || 0,
          // Subnode: values.Subnode || 0,
          // Intercom: values.Intercom || 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : 0,
          Invitation: fieldValues.Invitation ? fieldValues.Invitation / 100 : 0,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
              ? data?.data?.DealerNo
              : null,
          CustomerNo: values?.CustomerNo
            ? values?.CustomerNo
            : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
              ? data?.data?.CustomerNo
              : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : ![1, 2, 3].includes(userData?.role_value)
              ? data?.data?.OemNo
              : null,
        };
        if (!isValidNvrLicenseConfiguration()) {
          return openErrorNotification("At Least one NVR must be selected");
        }
        if (!isValidMobileLicenseConfiguration()) {
          return openErrorNotification(
            "At Least one Mobile Credential must be selected",
          );
        }

        const mergedData = {
          ...values,
          ...fieldValues,
          Options: optionsArray,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
              ? data?.data?.DealerNo
              : null,
          CustomerNo: values?.CustomerNo
            ? values?.CustomerNo
            : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
              ? data?.data?.CustomerNo
              : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : ![1, 2, 3].includes(userData?.role_value)
              ? data?.data?.OemNo
              : null,
          DeviceDesc: values?.DeviceDesc,
          UserId: values?.UserId,
          Password: values?.Password,
          AutoLogin: values?.AutoLogin,
          Options: optionsArray,
          Type: Number(values.Type),
          Channel: fieldValues.Channel ?? values.Channel ?? 0,
          Lockset: fieldValues.Lockset ?? values.Lockset ?? 0,
          ContLock: fieldValues.ContLock ?? values.ContLock ?? 0,
          // Temporary behavior: on edit/update requests always send Facegate as 0.
          Facegate: 0,
          Subnode: fieldValues.Subnode ?? values.Subnode ?? 0,
          // Mobile Phone card value is saved as Intercom
          Intercom:
            fieldValues.Intercom != null && fieldValues.Intercom !== ""
              ? Number(fieldValues.Intercom)
              : values.Intercom != null && values.Intercom !== ""
                ? Number(values.Intercom)
                : 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : values.Sicucom != null && values.Sicucom !== ""
                ? Number(values.Sicucom)
                : 0,
          Invitation:
            fieldValues.Invitation != null && fieldValues.Invitation !== ""
              ? Number(fieldValues.Invitation) / 100
              : values.Invitation
                ? values.Invitation / 100
                : 0,
        };
        setFormValuesData(modifiedValue);
        setPendingFormData(mergedData);
        setShowSummaryModal(true);
        // await putAction(modifiedValue);
      } else {
        if (!isValidNvrLicenseConfiguration()) {
          return openErrorNotification("At Least one NVR must be selected");
        }
        if (!isValidMobileLicenseConfiguration()) {
          return openErrorNotification(
            "At Least one Mobile Credential must be selected",
          );
        }
        const optionsArray = applyExpiredToOptions(
          Object.entries(licenseOptionsData)
            .filter(
              ([_, val]) => val.type === "toggle" && val.enabled && val.value,
            )
            .map(([_, val]) => Number(val.value)),
          values?.Expired,
        );

        // Extract field values from optionsData
        const fieldValues = {};
        Object.entries(licenseOptionsData).forEach(([key, val]) => {
          if (
            (val.type === "input" || val.type === "select") &&
            val.fieldName
          ) {
            fieldValues[val.fieldName] = val.quantity;
          }
        });
        const modifiedValue = {
          ...values,
          ...fieldValues,
          LicenseNo: selectedRow?.[0]?.LicenseNo,
          Options: optionsArray,
          Type: Number(values.Type),
          // Channel: values.Channel || 0,
          // Lockset: values.Lockset || 0,
          // ContLock: values.ContLock || 0,
          // Facegate: values.Facegate || 0,
          Facegate: 0,
          // Subnode: values.Subnode || 0,
          // Intercom: values.Intercom || 0,
          // Mobile Phone card value is saved as Intercom
          Intercom:
            fieldValues.Intercom != null && fieldValues.Intercom !== ""
              ? Number(fieldValues.Intercom)
              : 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : 0,
          Invitation: fieldValues.Invitation ? fieldValues.Invitation / 100 : 0,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : hasRole(7, 8, 9)
              ? userData?.dealer_no
              : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : hasRole(7, 8, 9)
              ? userData?.oem_no
              : null,
        };
        const mergedData = {
          ...modifiedValue,
          ...fieldValues,
          Options: optionsArray,
          Type: Number(values.Type),
          Facegate: 0,
          // Mobile Phone card value is saved as Intercom
          Intercom:
            fieldValues.Intercom != null && fieldValues.Intercom !== ""
              ? Number(fieldValues.Intercom)
              : 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : 0,
          Invitation: fieldValues.Invitation ? fieldValues.Invitation / 100 : 0,
        };
        // Store merged data and show summary modal
        setFormValuesData(modifiedValue);
        setPendingFormData(mergedData);
        setShowSummaryModal(true);
        // await postAction(modifiedValue);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    // setLicenseType(0);
    navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  useEffect(() => {
    setLicenseType(orderTypeOptions[0].value);
    if (!id) {
      form.setFieldsValue({
        // OemNo: modifiedOems[0]?.value,
        // Product: modifiedProducts[0]?.value,
        Model: modifiedModelsOptions[0]?.value,
        LicenseType: orderTypeOptions[0].value,
      });
    }
  }, [optionsData]);

  useEffect(() => {
    if (!id && optionsData?.data && codesData?.data) {
      const price = calculateLicenseTypePrice(
        modifiedModelsOptions[0]?.value,
        orderTypeOptions[0].value,
        codesData,
        modifiedModelsOptions,
      );
      const siteTypeprice = calculateSiteTypePrice(
        modifiedSiteTypes[0]?.value,
        orderTypeOptions[0].value,
        codesData,
        modifiedSiteTypes,
      );
      setLicenseTypePrice(price);
      setSiteTypePrice(siteTypeprice);
    }
  }, [optionsData, codesData, id]);

  useEffect(() => {
    if (
      !id ||
      loading ||
      !codesData?.data ||
      !modifiedOp ||
      !modifiedModelsOptions?.length ||
      !modifiedOpLicense ||
      !modifiedSiteTypes?.length
    )
      return;

    const getDeviceInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          const currentSiteType = data.data.SiteType;
          let initialLicenseType;

          if ([0, 1, 2].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[1].value; // lifetime
          } else if ([3, 4].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[0].value; // Monthly
          } else {
            initialLicenseType = 0; // default
          }
          setLicenseType(initialLicenseType);
          form.setFieldsValue({
            DeviceName: data?.data?.DeviceName,
            DeviceDesc: data?.data?.DeviceDesc,
            DealerNo: data?.data?.DealerNo,
            CustomerNo: data?.data?.CustomerNo,
            SiteType: data?.data?.SiteType,
            Type: data?.data?.Type,
            NodeType: data?.data?.NodeType,
            Options: data.data.Options?.map((item) => String(item)),
            Mac: data?.data?.Mac,
            Product: data?.data?.Product,
            Model: data?.data?.Model,
            OemNo: data?.data?.OemNo,
            AddTime: data?.data?.AddTime
              ? new Date(data.data.AddTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            ActTime: data?.data?.ActTime
              ? new Date(data.data.ActTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            StartTime: data?.data?.StartTime
              ? new Date(data.data.StartTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            EndTime: data?.data?.EndTime
              ? new Date(data.data.EndTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            Channel: data?.data?.Channel,
            Lockset: data?.data?.Lockset,
            Facegate: data?.data?.Facegate,
            Subnode: data?.data?.Subnode,
            ContLock: data?.data?.ContLock,
            Intercom: data?.data?.Intercom,
            Sicucom:
              data.data.Sicucom != null ? Number(data.data.Sicucom) : null,
            Invitation: data.data.Invitation
              ? data.data.Invitation * 100
              : null,
            LicenseKey:
              data?.data?.LicenseKey !== null
                ? String(data?.data?.LicenseKey)
                : "",
            SiteKey:
              data?.data?.SiteKey !== null ? String(data?.data?.SiteKey) : "",
            FirstName: data?.data?.FirstName
              ? String(data?.data?.FirstName)
              : "",
            LastName: data?.data?.LastName ? String(data?.data?.LastName) : "",
            Company: data?.data?.Company ? String(data?.data?.Company) : "",
            Email: data?.data?.Email ? String(data?.data?.Email) : "",
            Phone: data?.data?.Phone ? String(data?.data?.Phone) : "",
            Address: data?.data?.Address ? String(data?.data?.Address) : "",
            Address2: data?.data?.Address2 ? String(data?.data?.Address2) : "",
            InstallType: data?.data?.InstallType
              ? String(data?.data?.InstallType)
              : "",
            Suggestion: data?.data?.Suggestion
              ? String(data?.data?.Suggestion)
              : "",
            ProxyNo: data?.data?.ProxyNo ? String(data?.data?.ProxyNo) : "",
            SecurePort: data?.data?.SecurePort
              ? String(data?.data?.SecurePort)
              : "",
            DebugPort: data?.data?.DebugPort
              ? String(data?.data?.DebugPort)
              : "",
            Timeout: data?.data?.Timeout ? String(data?.data?.Timeout) : "",
            Debug: data?.data?.Debug
              ? data?.data?.Debug === 0
                ? "No"
                : "Yes"
              : "",
            Version: data?.data?.Version ? String(data?.data?.Version) : "",
            Https: data?.data?.Https
              ? data?.data?.Https === 0
                ? "No"
                : "Yes"
              : "",
            Timezone: data?.data?.Timezone ? String(data?.data?.Timezone) : "",
            Online: data?.data?.Online
              ? data?.data?.Debug === 0
                ? "No"
                : "Yes"
              : "",
            LicenseType: initialLicenseType,
            Expired: data.data.Options?.includes(64) ?? false,
          });

          setDefaultData((prev) => ({
            ...prev,
            OemNo: data?.data?.OemNo || null,
            DealerNo: data?.data?.DealerNo || null,
            CustomerNo: data?.data?.CustomerNo || null,
          }));

          const reconstructedOptionsData = {};

          // Handle toggle options (from Options array)
          if (data.data.Options && modifiedOpLicense) {
            data.data.Options.forEach((optionValue) => {
              const option = modifiedOpLicense.find(
                (opt) => opt.value === String(optionValue),
              );
              if (option) {
                const itemNo = getItemNoByLabel(option.label);
                reconstructedOptionsData[option.label] = {
                  type: "toggle",
                  enabled: true,
                  value: option.value,
                  itemNo: itemNo,
                  price: getPrice(
                    option.label,
                    codesData,
                    initialLicenseType,
                    1,
                    itemNo,
                  ),
                };
              }
            });
          }

          // Handle input/select options
          const inputFields = [
            { label: "Channel", fieldName: "Channel", type: "input" },
            { label: "Lockset", fieldName: "Lockset", type: "input" },
            { label: "Trilogy Lockset", fieldName: "ContLock", type: "input" },
            { label: "Facegate", fieldName: "Facegate", type: "input" },
            { label: "OSDP Door", fieldName: "Subnode", type: "input" },
            { label: "Mobile Phone", fieldName: "Intercom", type: "select" },
            {
              label: "Unit",
              fieldName: "Sicucom",
              type: "input",
            },
            {
              label: "Mobile Credential",
              fieldName: "Invitation",
              type: "select",
            },
          ];

          inputFields.forEach(({ label, fieldName, type: cardType }) => {
            const value = data.data[fieldName];
            if (value && value > 0) {
              const quantity = fieldName === "Invitation" ? value * 100 : value;

              const option = modifiedOp?.find((opt) => opt.label === label);
              const itemNo = getItemNoByLabel(label);
              reconstructedOptionsData[label] = {
                type: cardType,
                quantity: quantity,
                fieldName: fieldName,
                value: option?.value || null,
                itemNo: itemNo,
                price:
                  fieldName === "Intercom"
                    ? Number(data.data.IntercomPrice ?? 0) || 0
                    : getPrice(
                        label,
                        codesData,
                        initialLicenseType,
                        quantity,
                        itemNo,
                      ),
              };
            }
          });

          setLicenseOptionsData(reconstructedOptionsData);

          // Calculate and set prices
          const price = calculateLicenseTypePrice(
            data.data.Model,
            initialLicenseType,
            codesData,
            modifiedModelsOptions,
          );

          const siteTypeprice = calculateSiteTypePrice(
            data.data.SiteType,
            initialLicenseType,
            codesData,
            modifiedSiteTypes,
          );
          setSiteTypePrice(siteTypeprice);

          const doorPrice = calculateDoorPrice(
            data.data.Type,
            initialLicenseType,
            codesData,
          );
          setDoorPrice(doorPrice);

          setLicenseTypePrice(price);
          setSiteType(data.data.SiteType || 0);
          setNodeType(data.data.NodeType || 0);
          if (id && type === "edit") {
            setOriginalLicenseData({
              Model: data?.data?.Model,
              Type: data?.data?.Type,
              SiteType: data?.data?.SiteType,
              licenseTypePrice: price,
              siteTypePrice: siteTypeprice,
              doorPrice: doorPrice,
              optionsData: { ...reconstructedOptionsData },
            });
          }
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        console.log({ error });
        openErrorNotification("Error fetching data!");
      }
    };

    getDeviceInfoById();
  }, [
    id,
    data,
    loading,
    codesData,
    modifiedOp,
    modifiedModelsOptions,
    modifiedOpLicense,
    modifiedSiteTypes,
  ]);

  //toat for create
  useEffect(() => {
    if (postError) {
      isPaymentTriggeredApiRef.current = false;
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postError && postData) {
      if (paymentFlowInProgressRef.current) {
        // Save happens before payment; don't navigate/toast yet.
        return;
      }
      if (isPaymentTriggeredApiRef.current) {
        isPaymentTriggeredApiRef.current = false;
        if (id) {
          navigate(`/device/info/${id}`);
        } else {
          navigate(-1);
        }
        return;
      }
      openConfirmNotification("Success");
      // setLicenseType(0);
      navigate(-1);
    }
  }, [postError, postData]);

  //toat for update
  useEffect(() => {
    if (putError) {
      if (giftCardAwaitingPutRef.current) {
        giftCardAwaitingPutRef.current = false;
        pendingGiftCardMarkUsedPayloadRef.current = null;
      }
      isPaymentTriggeredApiRef.current = false;
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong",
      );
    } else if (!putError && putData) {
      refetch();
      if (skipNextDevicePutSuccessRef.current) {
        skipNextDevicePutSuccessRef.current = false;
        return;
      }
      if (paymentFlowInProgressRef.current) {
        // Save happens before payment; don't navigate/toast yet.
        if (giftCardAwaitingPutRef.current) {
          giftCardAwaitingPutRef.current = false;
          const pending = pendingGiftCardMarkUsedPayloadRef.current;
          pendingGiftCardMarkUsedPayloadRef.current = null;
          if (pending) {
            giftCardPostAction(pending);
          }
        }
        return;
      }
      if (isPaymentTriggeredApiRef.current) {
        isPaymentTriggeredApiRef.current = false;
        if (id) navigate(`/device/info/${id}`);
        return;
      }
      if (giftCardAwaitingPutRef.current) {
        giftCardAwaitingPutRef.current = false;
        const pending = pendingGiftCardMarkUsedPayloadRef.current;
        pendingGiftCardMarkUsedPayloadRef.current = null;
        if (pending) {
          giftCardPostAction(pending);
        }
        return;
      }
      openConfirmNotification("Success");
      // setLicenseType(0);
      navigate(-1);
      // navigate("/devicelist");
    }
  }, [putData, putError]);

  useEffect(() => {
    if (giftCardPostError) {
      openErrorNotification(
        giftCardPostError?.response?.data?.message || "Something went wrong",
      );
      prevGiftCardPostLoadingRef.current = giftCardPostLoading;
      return;
    }

    const postJustFinished =
      prevGiftCardPostLoadingRef.current &&
      !giftCardPostLoading &&
      !giftCardPostError &&
      giftCardPostData;

    prevGiftCardPostLoadingRef.current = giftCardPostLoading;

    if (!postJustFinished || !id) return;

    openConfirmNotification("Success");
    setShowGiftCardModal(false);
  }, [giftCardPostError, giftCardPostData, giftCardPostLoading, id]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/device");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  // Set default field value
  useEffect(() => {
    if (!id) {
      form.setFieldsValue({
        // OemNo: modifiedOems[0]?.value,
        Product: modifiedProductOptions[0]?.value,
        Model: modifiedModels[0]?.value,
        Options: [],
        SiteType: modifiedSiteTypes[0]?.value,
        // NodeType: modifiedNodeTypes[0]?.value,
        // NodeType: modifiedNodeTypes[0]?.value,
        // Channel: modifiedChannels[0]?.value,
        // Lockset: modifiedLocksets[0]?.value,
        // Facegate: modifiedFacegates[0]?.value,
        // Subnode: modifiedSubnodes[0]?.value,
        // ContLock: modifiedContLocks[0]?.value,
        // Intercom: modifiedIntercoms[0]?.value,
        // Sicucom: modifiedSicucoms[0]?.value,
        // Invitation: modifiedInvitations[0]?.value,
        // Storage: modifiedStorages[0]?.value,
      });
      // setOemNo(modifiedOems[0]?.value);
      // setDefaultData((prev) => ({
      //   ...prev,
      //   OemNo: modifiedOems[0]?.value,
      // }));
    }
  }, [optionsData]);
  useEffect(() => {
    if (data?.data?.SiteType && !form.getFieldValue("DealerNo")) {
      if ([3, 4].includes(data?.data?.SiteType) && type === "edit") {
        return;
      }
      if (id) {
        return;
      }
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? data?.data?.SiteType : 0,
      });
    }
  }, [form.getFieldValue("DealerNo")]);

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  useEffect(() => {
    optionDataRefetch();
    delaerOpRefetch();
    customerDataRefetch();
    if (
      defaultData?.OemNo ||
      defaultData?.DealerNo ||
      defaultData?.CustomerNo
      // ||
      // defaultData?.ProductionNo
    ) {
      form.setFieldsValue(defaultData);
    }
  }, [defaultData]);
  useEffect(() => {
    if (
      !id &&
      form.getFieldValue("OemNo") !== 1 &&
      form.getFieldValue("OemNo") != null
    ) {
      form.setFieldValue("NodeType", modifiedNodeTypes[0]?.value);
      setNodeType(1);
    }
    if (
      form.getFieldValue("OemNo") === 1 &&
      form.getFieldValue("DealerNo") == null
    ) {
      form.setFieldValue("NodeType", null);
      setNodeType(null);
    }
    if ([3, 4].includes(data?.data?.SiteType) && type === "edit") {
      return;
    }
    if (
      !form.getFieldValue("DealerNo") &&
      !id &&
      form.getFieldValue("SiteType") == null
    ) {
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? 3 : 0,
      });
    } else if (
      form.getFieldValue("DealerNo") &&
      licenseSiteType &&
      type !== "edit" &&
      type !== "info"
    ) {
      form.setFieldsValue({
        SiteType: licenseSiteType,
      });
    }
  }, [form.getFieldValue("DealerNo"), form.getFieldValue("OemNo")]);

  const applyGiftCardRowToDevice = (row) => {
    if (!id || !row) {
      return;
    }

    if (row.GiftCardItems?.length) {
      const valuesBeforeMerge = form.getFieldsValue(true);
      const validation = validateGiftCardItemsOldCodeMatchesForm(
        row.GiftCardItems,
        codesData,
        valuesBeforeMerge,
        "device",
      );
      if (!validation.ok) {
        openErrorNotification(validation.message, 12);
        giftCardAwaitingPutRef.current = false;
        pendingGiftCardMarkUsedPayloadRef.current = null;
        return;
      }

      const merged = mergeGiftCardItemsState(
        row.GiftCardItems,
        codesData,
        valuesBeforeMerge,
      );
      if (!merged) {
        giftCardAwaitingPutRef.current = false;
        pendingGiftCardMarkUsedPayloadRef.current = null;
        return;
      }

      const values = form.getFieldsValue(true);
      const siteTypeVal =
        merged.formPatch.SiteType ?? values.SiteType ?? data?.data?.SiteType;
      const resolvedLt =
        resolveLicenseTypeFromSiteType(siteTypeVal, orderTypeOptions) ??
        values.LicenseType ??
        data?.data?.LicenseType ??
        0;

      const channelForEnrich =
        merged.formPatch.Channel ?? values.Channel ?? data?.data?.Channel ?? 0;
      const invitationForEnrich =
        merged.formPatch.Invitation != null
          ? merged.formPatch.Invitation
          : values.Invitation != null
            ? values.Invitation
            : data?.data?.Invitation
              ? data.data.Invitation * 100
              : 0;

      const currentToggleOptions = Object.entries(licenseOptionsData)
        .filter(([_, val]) => val.type === "toggle" && val.enabled && val.value)
        .map(([_, val]) => Number(val.value));

      let giftOptions = enrichGiftCardOptionsWithChannelMobileChildren(
        merged.optionsArray,
        channelForEnrich,
        invitationForEnrich,
      );
      let optionsArray = applyExpiredToOptions(
        [...new Set([...currentToggleOptions, ...giftOptions])],
        form.getFieldValue("Expired"),
      );

      const nextValues = {
        ...values,
        ...merged.formPatch,
        LicenseType: resolvedLt,
        Options: optionsArray.map(String),
      };
      form.setFieldsValue(nextValues);

      setLicenseOptionsData((prev) => {
        const next = { ...prev };
        if (modifiedOpLicense) {
          optionsArray.forEach((num) => {
            if (num === 64) return;
            const opt = modifiedOpLicense.find((o) => Number(o.value) === num);
            if (opt) {
              const itemNo = getItemNoByLabel(opt.label);
              next[opt.label] = {
                type: "toggle",
                enabled: true,
                value: opt.value,
                itemNo: itemNo,
                price: getPrice(opt.label, codesData, resolvedLt, 1, itemNo),
              };
            }
          });
        }
        return next;
      });

      if (merged.formPatch.SiteType != null) {
        setSiteType(merged.formPatch.SiteType);
      }
      setLicenseType(resolvedLt);

      const model =
        merged.formPatch.Model ?? nextValues.Model ?? data?.data?.Model;
      const stForPrice =
        merged.formPatch.SiteType ??
        nextValues.SiteType ??
        data?.data?.SiteType;
      const doorVal =
        merged.formPatch.Type ?? nextValues.Type ?? data?.data?.Type;

      setLicenseTypePrice(
        calculateLicenseTypePrice(
          model,
          resolvedLt,
          codesData,
          modifiedModelsOptions,
        ),
      );
      setSiteTypePrice(
        calculateSiteTypePrice(stForPrice, resolvedLt, codesData),
      );
      setDoorPrice(calculateDoorPrice(doorVal, resolvedLt, codesData));

      const sicucom =
        merged.formPatch.Sicucom != null
          ? Number(merged.formPatch.Sicucom)
          : nextValues.Sicucom != null
            ? Number(nextValues.Sicucom)
            : (data?.data?.Sicucom ?? 0);
      const invitation =
        merged.formPatch.Invitation != null
          ? merged.formPatch.Invitation / 100
          : nextValues.Invitation != null
            ? Number(nextValues.Invitation) / 100
            : (data?.data?.Invitation ?? 0);

      const nodeTypeVal = nextValues.NodeType ?? data?.data?.NodeType ?? null;

      const payload = {
        Expired: form.getFieldValue("Expired") ?? false,
        LicenseType: resolvedLt,
        DeviceName: nextValues?.DeviceName ?? data?.data?.DeviceName ?? "",
        DeviceDesc: nextValues?.DeviceDesc ?? data?.data?.DeviceDesc ?? "",
        OemNo: nextValues?.OemNo
          ? nextValues.OemNo
          : ![1, 2, 3].includes(userData?.role_value)
            ? data?.data?.OemNo
            : null,
        DealerNo: nextValues?.DealerNo
          ? nextValues.DealerNo
          : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
            ? data?.data?.DealerNo
            : null,
        CustomerNo: nextValues?.CustomerNo
          ? nextValues.CustomerNo
          : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
            ? data?.data?.CustomerNo
            : null,
        SiteType: nextValues?.SiteType ?? data?.data?.SiteType,
        Product: nextValues?.Product ?? data?.data?.Product ?? 0,
        Mac: nextValues?.Mac ?? data?.data?.Mac ?? "",
        Model: nextValues?.Model ?? data?.data?.Model ?? 0,
        Type: Number(nextValues?.Type ?? data?.data?.Type ?? 0),
        NodeType: nodeTypeVal != null ? Number(nodeTypeVal) : null,
        AutoLogin: nextValues?.AutoLogin ?? data?.data?.AutoLogin ?? 0,
        Blocked: nextValues?.Blocked ?? data?.data?.Blocked ?? 0,
        Options: optionsArray,
        Channel:
          merged.formPatch.Channel ??
          nextValues.Channel ??
          data?.data?.Channel ??
          0,
        Lockset:
          merged.formPatch.Lockset ??
          nextValues.Lockset ??
          data?.data?.Lockset ??
          0,
        ContLock:
          merged.formPatch.ContLock ??
          nextValues.ContLock ??
          data?.data?.ContLock ??
          0,
        // Temporary behavior: on edit/update requests always send Facegate as 0.
        Facegate: 0,
        Subnode:
          merged.formPatch.Subnode ??
          nextValues.Subnode ??
          data?.data?.Subnode ??
          0,
        // Mobile Phone card value is saved as Intercom
        Intercom: nextValues.Intercom ?? data?.data?.Intercom ?? 0,
        Sicucom: sicucom,
        Invitation: invitation,
        is_prepurchased: true,
      };

      putAction(payload);
      return;
    }

    const itemNo = getItemNoByLabel(row.Item);
    const values = form.getFieldsValue(true);

    const codeValue = getCodeValueForGiftCard(
      itemNo,
      row.CodeName,
      row.Code,
      codesData,
    );

    if (itemNo === 1) values.SiteType = codeValue;
    else if (itemNo === 2) values.Model = codeValue;
    else if (itemNo === 3) values.Type = codeValue;

    form.setFieldsValue(values);

    let optionsArray = Object.entries(licenseOptionsData)
      .filter(([_, val]) => val.type === "toggle" && val.enabled && val.value)
      .map(([_, val]) => Number(val.value));
    if (optionsArray.length === 0 && data?.data?.Options?.length) {
      optionsArray = [...data.data.Options];
    }
    const licenseOpt = licenseOptions.find(
      (o) => o.label?.toLowerCase() === row.Item?.toLowerCase(),
    );
    if (licenseOpt != null) {
      const optionValue = Number(licenseOpt.value);
      if (!optionsArray.includes(optionValue)) optionsArray.push(optionValue);
    }
    optionsArray = applyExpiredToOptions(
      optionsArray,
      form.getFieldValue("Expired"),
    );

    const fieldValues = {};
    Object.entries(licenseOptionsData).forEach(([key, val]) => {
      if ((val.type === "input" || val.type === "select") && val.fieldName) {
        const quantity = Number(val.quantity);
        fieldValues[val.fieldName] = isNaN(quantity) ? val.quantity : quantity;
      }
    });
    const inputOpt = inputCardOptions.find(
      (opt) => opt.label?.toLowerCase() === row.Item?.toLowerCase(),
    );
    if (inputOpt?.fieldName) {
      const isInvitationHundredths = inputOpt.fieldName === "Invitation";
      fieldValues[inputOpt.fieldName] = isInvitationHundredths
        ? Number(codeValue) * 100
        : Number(codeValue);
    }

    const sicucom =
      fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
        ? Number(fieldValues.Sicucom)
        : 0;
    const invitation = fieldValues.Invitation
      ? fieldValues.Invitation / 100
      : 0;

    const channelVal = fieldValues.Channel ?? data?.data?.Channel ?? 0;
    const invitationVal = fieldValues.Invitation ?? data?.data?.Invitation ?? 0;
    optionsArray = enrichGiftCardOptionsWithChannelMobileChildren(
      optionsArray,
      channelVal,
      invitationVal,
    );

    const nodeTypeLegacy = values.NodeType ?? data?.data?.NodeType ?? null;

    const payload = {
      Expired: form.getFieldValue("Expired") ?? false,
      LicenseType: values?.LicenseType ?? data?.data?.LicenseType ?? 0,
      DeviceName: values?.DeviceName ?? data?.data?.DeviceName ?? "",
      DeviceDesc: values?.DeviceDesc ?? data?.data?.DeviceDesc ?? "",
      OemNo: values?.OemNo
        ? values.OemNo
        : ![1, 2, 3].includes(userData?.role_value)
          ? data?.data?.OemNo
          : null,
      DealerNo: values?.DealerNo
        ? values.DealerNo
        : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
          ? data?.data?.DealerNo
          : null,
      CustomerNo: values?.CustomerNo
        ? values.CustomerNo
        : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
          ? data?.data?.CustomerNo
          : null,
      SiteType: values?.SiteType ?? data?.data?.SiteType,
      Product: values?.Product ?? data?.data?.Product ?? 0,
      Mac: values?.Mac ?? data?.data?.Mac ?? "",
      Model: values?.Model ?? data?.data?.Model ?? 0,
      Type: Number(values?.Type) ?? data?.data?.Type ?? 0,
      NodeType: nodeTypeLegacy != null ? Number(nodeTypeLegacy) : null,
      AutoLogin: values?.AutoLogin ?? data?.data?.AutoLogin ?? 0,
      Blocked: values?.Blocked ?? data?.data?.Blocked ?? 0,
      Options: optionsArray,
      Channel: fieldValues.Channel ?? data?.data?.Channel ?? 0,
      Lockset: fieldValues.Lockset ?? data?.data?.Lockset ?? 0,
      ContLock: fieldValues.ContLock ?? data?.data?.ContLock ?? 0,
      // Temporary behavior: on edit/update requests always send Facegate as 0.
      Facegate: 0,
      Subnode: fieldValues.Subnode ?? data?.data?.Subnode ?? 0,
      // Mobile Phone card value is saved as Intercom
      Intercom: fieldValues.Intercom ?? data?.data?.Intercom ?? 0,
      Sicucom: sicucom,
      Invitation: invitation,
      is_prepurchased: true,
    };

    putAction(payload);
  };

  const applyLimitedLicenseIntercomUpdate = async (
    licenseCode,
    displayPrice = 0,
  ) => {
    const device = data?.data || {};
    const values = form.getFieldsValue(true);
    let optionsArray = Object.entries(licenseOptionsData)
      .filter(([_, val]) => val.type === "toggle" && val.enabled && val.value)
      .map(([_, val]) => Number(val.value));
    if (optionsArray.length === 0 && device.Options?.length) {
      optionsArray = [...device.Options];
    }
    optionsArray = applyExpiredToOptions(
      optionsArray,
      form.getFieldValue("Expired"),
    );

    const fieldValues = {};
    Object.entries(licenseOptionsData).forEach(([_, val]) => {
      if ((val.type === "input" || val.type === "select") && val.fieldName) {
        fieldValues[val.fieldName] = val.quantity;
      }
    });

    const intercomValue = Number(licenseCode);
    if (!Number.isFinite(intercomValue) || intercomValue < 0) {
      openErrorNotification("Selected limited card has no valid License Code.");
      return false;
    }

    const devicePutPayload = {
      Expired: form.getFieldValue("Expired") ?? false,
      LicenseType: values?.LicenseType ?? device.LicenseType ?? 0,
      DeviceName: values?.DeviceName ?? device.DeviceName ?? "",
      DeviceDesc: values?.DeviceDesc ?? device.DeviceDesc ?? "",
      OemNo: values?.OemNo
        ? values.OemNo
        : ![1, 2, 3].includes(userData?.role_value)
          ? device.OemNo
          : null,
      DealerNo: values?.DealerNo
        ? values.DealerNo
        : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
          ? device.DealerNo
          : null,
      CustomerNo: values?.CustomerNo
        ? values.CustomerNo
        : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
          ? device.CustomerNo
          : null,
      SiteType: values?.SiteType ?? device.SiteType,
      Product: values?.Product ?? device.Product ?? 0,
      Mac: values?.Mac ?? device.Mac ?? "",
      Model: values?.Model ?? device.Model ?? 0,
      Type: Number(values?.Type ?? device.Type ?? 0),
      NodeType:
        values?.NodeType != null
          ? Number(values.NodeType)
          : device.NodeType != null
            ? Number(device.NodeType)
            : null,
      AutoLogin: values?.AutoLogin ?? device.AutoLogin ?? 0,
      Blocked: values?.Blocked ?? device.Blocked ?? 0,
      Options: optionsArray,
      Channel: fieldValues.Channel ?? device.Channel ?? 0,
      Lockset: fieldValues.Lockset ?? device.Lockset ?? 0,
      ContLock: fieldValues.ContLock ?? device.ContLock ?? 0,
      Facegate: 0,
      Subnode: fieldValues.Subnode ?? device.Subnode ?? 0,
      Intercom: intercomValue,
      Sicucom:
        fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
          ? Number(fieldValues.Sicucom)
          : Number(device.Sicucom ?? 0),
      Invitation:
        fieldValues.Invitation != null && fieldValues.Invitation !== ""
          ? Number(fieldValues.Invitation) / 100
          : Number(device.Invitation ?? 0),
    };

    skipNextDevicePutSuccessRef.current = true;
    paymentFlowInProgressRef.current = true;
    const putResult = await putAction(devicePutPayload);
    paymentFlowInProgressRef.current = false;

    if (!putResult) {
      skipNextDevicePutSuccessRef.current = false;
      openErrorNotification("Order created but updating Mobile Phone failed.");
      return false;
    }

    form.setFieldsValue({ Intercom: intercomValue });
    setLicenseOptionsData((prev) => ({
      ...prev,
      "Mobile Phone": {
        type: "select",
        quantity: intercomValue,
        price: Number(displayPrice ?? 0) || 0,
        fieldName: "Intercom",
        value: null,
        itemNo: 207,
      },
    }));
    return true;
  };

  const breadcrumbItems = [
    {
      label: "Device",
      href: "/device",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/device/info/${id}`
          : `/device/edit/${id}`
        : "/device/add",
    },
  ];
  const totalPrice = calculateTotals(
    licenseOptionsData,
    licenseTypePrice,
    doorPrice,
    siteTypePrice,
  );

  const getCommonButtons = (
    isDisabled = false,
    showExpired = true,
    showLicenseType = true,
  ) => {
    const buttons = [];

    if (showExpired) {
      buttons.push({
        name: "Expired",
        label: "Expired",
        toggle: true,
        disabled: isDisabled,
        onClick: isDisabled ? undefined : () => {},
      });
    }
    // if (showLicenseType) {
    //   buttons.push({
    //     name: "LicenseType",
    //     label: "LicenseType",
    //     radioOptions: orderTypeOptions,
    //     toggle: true,
    //     disabled: true,
    //     onChange: (value) => {
    //       setLicenseType(value);
    //       const price = calculateLicenseTypePrice(
    //         form.getFieldValue("Model"),
    //         value,
    //         codesData,
    //         modifiedModelsOptions,
    //       );
    //       const siteTypeprice = calculateSiteTypePrice(
    //         form.getFieldValue("SiteType"),
    //         value,
    //         codesData,
    //         modifiedSiteTypes,
    //       );
    //       setLicenseTypePrice(price);
    //       setSiteTypePrice(siteTypeprice);
    //     },
    //   });
    // }
    return buttons;
  };

  const getTotalPriceButton = () => ({
    label: isLifetimeMode ? "Additional Price: " : "Monthly Price: ",
    renderLabel: true,
    value: `$ ${displayPrice.toFixed(2)}`,
  });

  const getActionButtons = (showDelete = false, showEdit = true) => {
    const buttons = showEdit
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => navigate(`/device/edit/${id}`),
          },
        ]
      : [];

    if (showDelete) {
      buttons.push({
        label: "Delete",
        icon: <DeleteOutlined />,
        onClick: () => setShowModal(true),
      });
    }

    buttons.push({
      label: "List",
      icon: <UnorderedListOutlined />,
      onClick: () => navigate(-1),
    });

    return buttons;
  };

  const getEditButtons = (showLicenseSelect = false, showTotalPrice = true) => {
    const buttons = [];

    if (showTotalPrice) {
      buttons.push(getTotalPriceButton());
    }

    if (showLicenseSelect) {
      buttons.push({
        label: "License Select",
        icon: <FolderOpenOutlined />,
        onClick: () => setShowCommonModal(true),
      });
    }

    buttons.push(
      {
        label: "Apply",
        icon: <CheckCircleOutlined />,
        onClick: () => form.submit(),
        loading: postLoading || putLoading,
      },
      {
        label: "Cancel",
        icon: <CloseOutlined />,
        onClick: onReset,
      },
    );

    return buttons;
  };

  const getButtonsData = () => {
    const roleValue = userData?.role_value;
    const isRoleGroup1 = [1, 2].includes(roleValue);
    const isRoleGroup2 = [4, 5].includes(roleValue);
    const isRoleGroup3 = [3, 6, 9].includes(roleValue);
    const isRoleGroup4 = [7, 8].includes(roleValue);
    const shouldHideTotalPrice = nodeType === 2; // Hide price only when nodeType is exactly 2

    // INFO mode
    if (type === "info") {
      if (isRoleGroup1) {
        const limitedBtn = [0, 1, 2].includes(data?.data?.SiteType)
          ? [
              {
                label: "Limited License",
                icon: <FaCalendarDays />,
                onClick: () => setShowLimitedLicenseModal(true),
              },
            ]
          : [];
        return [
          ...limitedBtn,
          ...getCommonButtons(true, true, false),
          // getTotalPriceButton(),
          ...getActionButtons(true),
        ];
      }
      if (isRoleGroup3) {
        return [
          ...getCommonButtons(true, true, false),
          // getTotalPriceButton(),
          ...getActionButtons(false, false),
        ];
      }

      if (isRoleGroup2) {
        const baseButtons = getCommonButtons(true, true, false);

        // if (shouldHideTotalPrice) {
        //   return [...baseButtons, ...getActionButtons(false)];
        // }

        return [
          ...baseButtons,
          // getTotalPriceButton(),
          ...getActionButtons(false),
        ];
      }
      if (isRoleGroup4) {
        const prepurchasedBtn = [0, 1, 2].includes(data?.data?.SiteType)
          ? [
              {
                label: "Limited License",
                icon: <FaCalendarDays />,
                onClick: () => setShowLimitedLicenseModal(true),
              },
              {
                label: "Prepurchased License",
                icon: <GiftFilled />,
                onClick: () => setShowGiftCardModal(true),
              },
            ]
          : [];
        const baseButtons = [
          ...prepurchasedBtn,
          ...getCommonButtons(true, true, false),
        ];

        // if (shouldHideTotalPrice) {
        //   return [...baseButtons, ...getActionButtons(false, true)];
        // }

        return [
          ...baseButtons,
          // getTotalPriceButton(),
          ...getActionButtons(false, true),
        ];
      }

      // Other roles
      return [
        getTotalPriceButton(),
        {
          label: "List",
          icon: <UnorderedListOutlined />,
          onClick: () => navigate(-1),
        },
      ];
    }

    // EDIT mode
    if (type === "edit") {
      const baseButtons = getCommonButtons(false);

      if (isRoleGroup2 && shouldHideTotalPrice) {
        return [...baseButtons, ...getEditButtons(false, false)];
      }

      if (hasRole(7, 8, 9)) {
        return [...baseButtons, ...getEditButtons(false, false)];
      }

      return [...baseButtons, ...getEditButtons(false, true)];
    }

    // CREATE mode (default)
    const baseButtons = getCommonButtons(false);

    if (hasRole(7, 8, 9)) {
      return [...baseButtons, ...getEditButtons(false, false)];
    }

    return [...baseButtons, ...getEditButtons(true, true)];
  };
  const isLifetimeMode = licenseType === orderTypeOptions[1].value;

  const displayPrice =
    Number(
      isLifetimeMode
        ? (() => {
            const originalTotal = originalLicenseData
              ? calculateTotals(
                  originalLicenseData.optionsData || {},
                  originalLicenseData.licenseTypePrice || 0,
                  originalLicenseData.doorPrice || 0,
                  originalLicenseData.siteTypePrice || 0,
                )
              : 0;
            return Math.max(totalPrice - originalTotal, 0);
          })()
        : totalPrice,
    ) || 0;

  const isPriceChanged = (currentPrice, originalPrice) => {
    if (type !== "edit") return false;
    if (!isLifetimeMode) return false;
    return Number(currentPrice) > Number(originalPrice ?? 0);
  };

  const origModelPrice = originalLicenseData?.licenseTypePrice ?? 0;
  const origSiteTypePrice = originalLicenseData?.siteTypePrice ?? 0;
  const origDoorPrice = originalLicenseData?.doorPrice ?? 0;

  const buttonsData = getButtonsData();

  useEffect(() => {
    if (
      id &&
      type === "edit" &&
      [3, 6, 10, 11, 12].includes(userData?.role_value)
    ) {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    const currentSiteType = form.getFieldValue("SiteType");

    if (currentSiteType === undefined) return;
    if (id && loading) return;
    let newLicenseType;

    if ([0, 1, 2].includes(currentSiteType)) {
      newLicenseType = orderTypeOptions[1].value; // lifetime
    } else if ([3, 4].includes(currentSiteType)) {
      newLicenseType = orderTypeOptions[0].value; // Monthly
    }

    if (newLicenseType === undefined) return;

    // Update regardless of previous value to handle page transitions
    setLicenseType(newLicenseType);
    form.setFieldsValue({ LicenseType: newLicenseType });

    // Recalculate prices with the new license type
    const price = calculateLicenseTypePrice(
      form.getFieldValue("Model"),
      newLicenseType,
      codesData,
      modifiedModelsOptions,
    );
    const siteTypeprice = calculateSiteTypePrice(
      currentSiteType,
      newLicenseType,
      codesData,
      modifiedSiteTypes,
    );
    const doorPriceValue = calculateDoorPrice(
      form.getFieldValue("Type"),
      newLicenseType,
      codesData,
    );

    setLicenseTypePrice(price);
    setSiteTypePrice(siteTypeprice);
    setDoorPrice(doorPriceValue);
  }, [
    sitetype,
    codesData,
    modifiedModelsOptions,
    modifiedSiteTypes,
    type,
    data,
  ]);

  return (
    <div>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Dealer" ? (
              <DealerIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Customer" ? (
              <AccountIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <CommonModal
        title="Prepurchased License"
        icon={GiftFilled}
        content={
          <GiftCardItemsForm ref={giftCardRef} dealerNo={userData?.dealer_no} />
        }
        isVisible={showGiftCardModal}
        onClose={() => setShowGiftCardModal(false)}
        width={900}
        footerComp={
          <div className="flex justify-center mt-4 gap-4">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              loading={giftCardPostLoading || putLoading}
              disabled={giftCardPostLoading || putLoading}
              onClick={async () => {
                const selected = giftCardRef.current?.getSelectedRows() ?? [];
                if (!selected.length) {
                  openErrorNotification("Please select at least one item.");
                  return;
                }
                if (!id) {
                  openErrorNotification("Device is not available.");
                  return;
                }
                const usedMac = form.getFieldValue("Mac");
                const usedTime = new Date()
                  .toISOString()
                  .replace(/(\.\d{3})Z$/, "$1000Z");
                const markUsedPayload = {
                  dealer_no: userData?.dealer_no,
                  items: selected.map((row) => {
                    const item = {
                      item_no: row.ItemNo,
                      used_mac: usedMac,
                      used_time: usedTime,
                    };
                    if (row.PurchaseNo != null && row.PurchaseNo !== "") {
                      item.purchase_no = row.PurchaseNo;
                    }
                    const gcn = row.GiftCardNo ?? row.gift_card_no;
                    if (gcn != null && gcn !== "") {
                      item.GiftCardNo = gcn;
                    }
                    return item;
                  }),
                };
                giftCardAwaitingPutRef.current = true;
                pendingGiftCardMarkUsedPayloadRef.current = markUsedPayload;
                applyGiftCardRowToDevice(selected[0]);
              }}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              onClick={() => setShowGiftCardModal(false)}
              className="reset-button w-[104px] h-[30px] font-medium"
            >
              <CloseOutlined className="font-medium" />
              Close
            </Button>
          </div>
        }
      />
      <CommonModal
        title="Limited License"
        icon={FaCalendarDays}
        content={
          <LimitedLicenseForm
            ref={limitedLicenseRef}
            currentLimitedCardNo={data?.data?.LimitedCardNo}
            limitedOrderStartDate={data?.data?.LimitedOrderStartDate}
            limitedOrderEndDate={data?.data?.LimitedOrderEndDate}
            dealerDiscountPercent={summaryDealerDiscountPercent}
            entityLabel="device"
            onAlreadyAppliedChange={setLimitedApplyDisabled}
          />
        }
        isVisible={showLimitedLicenseModal}
        onClose={() => {
          setShowLimitedLicenseModal(false);
          setLimitedApplyDisabled(false);
        }}
        width={900}
        footerComp={
          <div className="flex justify-center mt-4 gap-4">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              disabled={limitedApplyDisabled}
              onClick={() => {
                if (limitedApplyDisabled) {
                  openErrorNotification(
                    "This Limited License is already applied. Select a different item.",
                  );
                  return;
                }
                const selected =
                  limitedLicenseRef.current?.getSelectedRows() ?? [];
                if (!selected.length) {
                  openErrorNotification("Please select at least one item.");
                  return;
                }
                if (!id) {
                  openErrorNotification("Device is not available.");
                  return;
                }

                const selectedCard = selected[0];
                const formFields = form.getFieldsValue(true);
                const effectiveDealerNo = resolveEffectiveDealerNo(formFields);
                const hasDealerForPayment =
                  effectiveDealerNo != null && effectiveDealerNo !== "";
                const { billingType: dealerBillingType, discountPercent } =
                  getDealerMeta(effectiveDealerNo);
                // Dealers: BillingType 1 only. Admins: always allow when dealer exists.
                const shouldShowPaymentModal =
                  hasDealerForPayment &&
                  (isSystemUser ||
                    dealerBillingType == null ||
                    dealerBillingType === 1);

                const cardPrice = Number(selectedCard?.Price);
                if (!Number.isFinite(cardPrice) || cardPrice <= 0) {
                  openErrorNotification(
                    "Selected limited card has no valid price.",
                  );
                  return;
                }

                if (!shouldShowPaymentModal) {
                  openErrorNotification(
                    isSystemUser
                      ? "Dealer is required to make this payment."
                      : "Payment is not available for this dealer billing type.",
                  );
                  return;
                }

                const currentLimitedCardNo = data?.data?.LimitedCardNo;
                const currentCard =
                  limitedLicenseRef.current?.getCardByLimitedCardNo?.(
                    currentLimitedCardNo,
                  );
                const currentTerm =
                  currentCard?.Term ??
                  limitedOrdersPreviewData?.data?.[0]?.Term ??
                  null;
                const currentOrder = pickCurrentLimitedOrder(
                  limitedOrdersPreviewData?.data,
                  currentTerm,
                );
                const summary = buildLimitedLicenseSummary({
                  selectedCard,
                  discountPercent,
                  currentTerm,
                  currentCardBasePrice: currentCard?.Price,
                  currentPaidAmount:
                    currentOrder?.Amount ?? data?.data?.IntercomPrice,
                  currentOrder,
                  currentOrderStartDate: data?.data?.LimitedOrderStartDate,
                  currentOrderEndDate: data?.data?.LimitedOrderEndDate,
                });

                if (!summary?.next?.amount || summary.next.amount <= 0) {
                  openErrorNotification(
                    "Selected limited card has no valid amount.",
                  );
                  return;
                }

                selectedLimitedCardRef.current = selectedCard;
                setLimitedLicenseSummary(summary);
                setShowLimitedLicenseModal(false);
                setLimitedApplyDisabled(false);
                setShowLimitedLicenseSummary(true);
              }}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              onClick={() => {
                setShowLimitedLicenseModal(false);
                setLimitedApplyDisabled(false);
              }}
              className="reset-button w-[104px] h-[30px] font-medium"
            >
              <CloseOutlined className="font-medium" />
              Close
            </Button>
          </div>
        }
      />
      <Modal
        open={showLimitedLicenseSummary}
        onCancel={() => {
          setShowLimitedLicenseSummary(false);
          setLimitedLicenseSummary(null);
          selectedLimitedCardRef.current = null;
        }}
        closeIcon={false}
        footer={null}
        width={900}
        centered
        destroyOnClose
      >
        <LimitedLicenseConfirmForm
          summary={limitedLicenseSummary}
          onCancel={() => {
            setShowLimitedLicenseSummary(false);
            setLimitedLicenseSummary(null);
            selectedLimitedCardRef.current = null;
            setShowLimitedLicenseModal(true);
          }}
          onConfirm={() => {
            const summary = limitedLicenseSummary;
            const selectedCard = selectedLimitedCardRef.current;
            if (!summary?.next || !selectedCard) {
              openErrorNotification(
                "Limited License summary is not available.",
              );
              return;
            }
            const amountDue = Number(summary.amountDue ?? 0);
            const payback = Number(summary.payback ?? 0);
            const newAmount = Number(summary.next.amount ?? 0);

            setPendingSubmitMode("limited");
            setPendingUpdatePayload({
              LimitedCardNo: selectedCard.LimitedCardNo,
              Term: selectedCard.Term,
              LicenseCode: selectedCard.LicenseCode,
              Price: newAmount,
              Amount: amountDue,
              Payback: payback > 0 ? payback : null,
            });
            setPriceChangeAmount(Math.max(amountDue, 0));
            setShowLimitedLicenseSummary(false);

            if (amountDue > 0) {
              setPaymentModal(true);
              return;
            }

            (async () => {
              try {
                const deviceNo =
                  data?.data?.DeviceNo ??
                  (id != null && id !== "" ? Number(id) : null);
                if (deviceNo == null || Number.isNaN(Number(deviceNo))) {
                  openErrorNotification("Device is not available.");
                  return;
                }
                const orderResult = await limitedOrderPostAction({
                  DeviceNo: Number(deviceNo),
                  Amount: 0,
                  Price: newAmount,
                  Payback: payback > 0 ? payback : null,
                  LimitedCardNo: selectedCard.LimitedCardNo,
                });
                if (!orderResult) {
                  openErrorNotification("Limited order failed.");
                  return;
                }
                const licenseCode = Number(selectedCard.LicenseCode);
                const applied = await applyLimitedLicenseIntercomUpdate(
                  licenseCode,
                  newAmount,
                );
                if (!applied) return;
                setPendingUpdatePayload(null);
                setPendingSubmitMode(null);
                setLimitedLicenseSummary(null);
                selectedLimitedCardRef.current = null;
                openConfirmNotification("Success");
                navigate(`/device/info/${id}`);
              } catch (e) {
                openErrorNotification(
                  e?.response?.data?.message ||
                    e?.message ||
                    "Something went wrong",
                );
              }
            })();
          }}
        />
      </Modal>
      <CommonModal
        title="Select License"
        icon={LicenseIcon}
        content={
          <LicenseSelectForm
            setSelectedRow={setSelectedRow}
            type="Initial License"
          />
        }
        isVisible={showCommonModal}
        onClose={() => setShowCommonModal(false)}
        width={900}
        onConfirm={() => {
          if (!individualLicenseData?.data) {
            openErrorNotification("Please select a license before apply.");
            return;
          }
          const currentSiteType = Number(form.getFieldValue("SiteType"));

          let initialLicenseType;

          if ([0, 1, 2].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[1].value; // lifetime
          } else if ([3, 4].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[0].value; // Monthly
          } else {
            initialLicenseType = 0; // default
          }
          form.setFieldsValue({
            Options: individualLicenseData?.data?.Options?.map((item) =>
              String(item),
            ),
            Product: individualLicenseData?.data?.Product,
            Model: individualLicenseData?.data?.Model,
            Type: individualLicenseData.data.Type,
            SiteType: individualLicenseData?.data?.SiteType,
            // OemNo: individualLicenseData.data.OemNo,
            Invitation: individualLicenseData.data.Invitation
              ? individualLicenseData.data.Invitation * 100
              : undefined,
            Channel: individualLicenseData.data.Channel,
            Lockset: individualLicenseData.data.Lockset,
            Facegate: individualLicenseData.data.Facegate,
            Subnode: individualLicenseData.data.Subnode,
            ContLock: individualLicenseData.data.ContLock,
            Intercom: individualLicenseData.data.Intercom,
            Sicucom:
              individualLicenseData.data.Sicucom != null
                ? Number(individualLicenseData.data.Sicucom)
                : undefined,
            // Storage: individualLicenseData.data.Storage,
          });
          const reconstructedOptionsData = {};

          // Handle toggle options (from Options array)
          if (individualLicenseData?.data?.Options && modifiedOpLicense) {
            individualLicenseData?.data?.Options.forEach((optionValue) => {
              const option = modifiedOpLicense.find(
                (opt) => opt.value === String(optionValue),
              );
              if (option) {
                const itemNo = getItemNoByLabel(option.label);
                reconstructedOptionsData[option.label] = {
                  type: "toggle",
                  enabled: true,
                  value: option.value,
                  price: getPrice(
                    option.label,
                    codesData,
                    initialLicenseType,
                    1,
                    itemNo,
                  ),
                };
              }
            });
          }
          const inputFields = [
            { label: "Channel", fieldName: "Channel", type: "input" },
            { label: "Lockset", fieldName: "Lockset", type: "input" },
            { label: "Trilogy Lockset", fieldName: "ContLock", type: "input" },
            { label: "Facegate", fieldName: "Facegate", type: "input" },
            { label: "OSDP Door", fieldName: "Subnode", type: "input" },
            { label: "Mobile Phone", fieldName: "Intercom", type: "select" },
            {
              label: "Unit",
              fieldName: "Sicucom",
              type: "input",
            },
            {
              label: "Mobile Credential",
              fieldName: "Invitation",
              type: "select",
            },
          ];

          inputFields.forEach(({ label, fieldName, type: cardType }) => {
            const value = individualLicenseData?.data?.[fieldName];
            if (value && value > 0) {
              const quantity = fieldName === "Invitation" ? value * 100 : value;

              const option = modifiedOp?.find((opt) => opt.label === label);
              const itemNo = getItemNoByLabel(label);

              reconstructedOptionsData[label] = {
                type: cardType,
                quantity: quantity,
                fieldName: fieldName,
                value: option?.value || null,
                itemNo: itemNo,
                price:
                  fieldName === "Intercom"
                    ? Number(individualLicenseData?.data?.IntercomPrice ?? 0) ||
                      0
                    : getPrice(
                        label,
                        codesData,
                        initialLicenseType,
                        quantity,
                        itemNo,
                      ),
              };
            }
          });
          setLicenseOptionsData(reconstructedOptionsData);

          // Calculate and set prices
          const price = calculateLicenseTypePrice(
            individualLicenseData?.data?.Model,
            initialLicenseType,
            codesData,
            modifiedModelsOptions,
          );
          const siteTypeprice = calculateSiteTypePrice(
            currentSiteType,
            initialLicenseType,
            codesData,
            modifiedSiteTypes,
          );
          const doorPrice = calculateDoorPrice(
            individualLicenseData?.data?.Type,
            initialLicenseType,
            codesData,
          );

          setLicenseTypePrice(price);
          setSiteTypePrice(siteTypeprice);
          setDoorPrice(doorPrice);
          setShowCommonModal(false);
          if (individualLicenseData?.data?.SiteType != null) {
            setSiteType(individualLicenseData.data.SiteType);
            setLicenseSiteType(individualLicenseData.data.SiteType);
          }
        }}
      />

      <div className="">
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
            <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
              <CommonButton buttonsData={buttonsData} />
            </CommonBreadcrumb>
          </div>
          <div className="overflow-hidden border bg-white rounded-[4px]">
            <div className="flex items-center bg-gray-200 p-2.5">
              <DeviceIcon className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                Device
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Device Name"
                    name="DeviceName"
                    disable={type === "info"}
                    loading={loading}
                    // required
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Description"
                    name="DeviceDesc"
                    disable={type === "info"}
                    loading={loading}
                  />
                </Col>
                {/* {[1, 2, 3].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Production"
                      name="ProductionNo"
                      options={modifiedProductions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      handleCreateNew={handleCreateNew}
                      type={"Production"}
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          ProductionNo: value,
                        }));
                        form.setFieldsValue({
                          ProductionNo: value,
                        });
                      }}
                    />
                  </Col>
                )} */}
                {[1, 2, 3].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="OEM"
                      name="OemNo"
                      options={modifiedOems}
                      placeholder="Please select"
                      disabled={type === "info"}
                      required
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          OemNo: value,
                          DealerNo: null,
                          CustomerNo: null,
                        }));
                        setOemNo(value);
                        setDealerNo(null);
                        form.setFieldsValue({
                          DealerNo: null,
                          CustomerNo: null,
                        });
                      }}
                      handleCreateNew={handleCreateNew}
                      type={"OEM"}
                      allowClear={false}
                      loading={loading}
                    />
                  </Col>
                )}
                {[1, 2, 3, 4, 5, 6].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Dealer"
                      name="DealerNo"
                      options={modifiedDealers}
                      placeholder="Please select"
                      disabled={type === "info" || !defaultData?.OemNo}
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          DealerNo: value,
                          CustomerNo: null,
                        }));
                        setDealerNo(value);
                        form.setFieldsValue({
                          CustomerNo: null,
                        });
                        if (!value) {
                          form.setFieldsValue({
                            SiteType: hasRole(7, 8, 9)
                              ? data?.data?.SiteType
                              : 0,
                          });
                        }
                      }}
                      handleCreateNew={handleCreateNew}
                      type={"Dealer"}
                      loading={loading}
                      // customPlaceholderColor
                    />
                  </Col>
                )}
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Customer"
                      name="CustomerNo"
                      options={modifiedCustomers}
                      placeholder="Please select"
                      disabled={
                        type === "info" ||
                        (hasRole(7, 8, 9)
                          ? !OemNo && !dealerNo
                          : !defaultData?.DealerNo)
                      }
                      handleCreateNew={handleCreateNew}
                      type={"Customer"}
                      loading={loading}
                    />
                  </Col>
                )}
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{
                    display: type === "info" || isSystemUser ? "block" : "none",
                  }}
                >
                  <CustomSelect
                    label="Node Type"
                    name="NodeType"
                    options={modifiedNodeTypes}
                    placeholder="Please select"
                    disabled={type === "info"}
                    onChange={(value) => {
                      setNodeType(value);
                    }}
                    loading={loading}
                    required={form.getFieldValue("OemNo") > 1}
                  />
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Site Type"
                    name="SiteType"
                    options={
                      ["edit", "info"].includes(type)
                        ? form.getFieldValue("SiteType") === 3
                          ? modifiedSiteTypeOptions?.filter(
                              (item) => item.value === 3,
                            )
                          : form.getFieldValue("SiteType") === 4
                            ? modifiedSiteTypeOptions?.filter(
                                (item) => item.value === 4,
                              )
                            : modifiedSiteTypeOptions?.filter(
                                (item) => ![3, 4].includes(item.value),
                              )
                        : modifiedSiteTypeOptions
                    }
                    placeholder="Please select"
                    disabled={
                      type === "info" || !nodeType
                      // || !form.getFieldValue("DealerNo")
                    }
                    onChange={(value) => {
                      handleSiteTypeChange(value);
                      setSiteType(value);
                      if (
                        [3, 4].includes(value) &&
                        form.getFieldValue("Product") !== 0
                      ) {
                        form.setFieldValue("Product", 0);
                      }
                    }}
                    loading={loading}
                    allowClear={false}
                    showIcons
                    postfix={
                      <span className="flex items-center">
                        <span className="h-7 border-l border-gray-300 mr-2"></span>
                        <span
                          className={`text-xs font-medium mr-1 ${isPriceChanged(siteTypePrice, origSiteTypePrice) ? "text-green-600" : "text-gray-500"}`}
                        >
                          $
                        </span>
                        <span
                          className={`text-xs font-medium ${isPriceChanged(siteTypePrice, origSiteTypePrice) ? "text-green-600" : "text-gray-800"}`}
                        >
                          {siteTypePrice.toFixed(2)}
                        </span>
                      </span>
                    }
                  />
                </Col>

                {[0, 1, 2].includes(sitetype) ? (
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{
                      display:
                        type === "info" || isSystemUser ? "block" : "none",
                    }}
                  >
                    <CustomSelect
                      label="Product"
                      name="Product"
                      options={
                        type === "edit" &&
                        [3, 4].includes(sitetype) &&
                        form.getFieldValue("Product") !== 0
                          ? modifiedProductOptions.filter(
                              (item) =>
                                item.value === form.getFieldValue("Product"),
                            )
                          : [3, 4].includes(sitetype)
                            ? modifiedProductOptions.filter(
                                (item) => item.value === 0,
                              )
                            : modifiedProductOptions
                      }
                      placeholder="Please select"
                      disabled={
                        type === "info" ||
                        // hasRole(7, 8, 9) ||
                        (type === "edit" &&
                          [3, 4].includes(sitetype) &&
                          form.getFieldValue("Product") !== 0)
                      }
                      required
                      allowClear={!type}
                      loading={loading}
                      showIcons
                    />
                  </Col>
                ) : null}
                {[0, 1, 2].includes(sitetype) ? (
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{
                      display:
                        type === "info" || isSystemUser ? "block" : "none",
                    }}
                  >
                    <CustomInput
                      label="MAC"
                      name="Mac"
                      disable={id || type === "info"}
                      required={[0, 1, 2].includes(sitetype)}
                      rules={[{ validator: macValidator }]}
                      loading={loading}
                    />
                  </Col>
                ) : null}
                {/* {type === "info" && [0, 1, 2].includes(sitetype) ? (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Key"
                      name="SiteKey"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                ) : null} */}
                {type === "info" && data?.data?.LicenseKey && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="License Key"
                      name="LicenseKey"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                )}
                {type === "info" && isSystemUser && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Add Time"
                      name="AddTime"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {type === "info" && isSystemUser && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Activate Time"
                      name="ActTime"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {/* {[2, 3].includes(form.getFieldValue("SiteType")) &&
                  type === "info" &&
                  isSystemUser && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Start Time"
                        name="StartTime"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )}
                {[2, 3].includes(form.getFieldValue("SiteType")) &&
                  type === "info" &&
                  isSystemUser && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="End Time"
                        name="EndTime"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )} */}
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mt-2 ">
                  <CustomSwitch
                    label="Expired"
                    name="Expired"
                    defaultChecked={0}
                    disabled={type === "info"}
                  />
                </Col> */}
              </Row>
              {/* <Row gutter={[16, 4]} className="mt-1"> */}
              {/* {type === "info" && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Key"
                      name="SiteKey"
                      disabled={type === "info"}
                    />
                  </Col>
                )} */}
              {/* </Row> */}
            </div>
          </div>
          <div
            className={`${loading || (nodeType === 2 && (isDealerUser || isOemUser)) ? "hidden" : ""}`}
          >
            <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  License Information
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Model"
                      name="Model"
                      options={modifiedModelsOptions}
                      placeholder="Please select"
                      disabled={type === "info"}
                      required
                      loading={loading}
                      onChange={handleModelChange}
                      showIcons
                      postfix={
                        <span className="flex items-center">
                          <span className="h-7 border-l border-gray-300 mr-2"></span>
                          <span
                            className={`text-xs font-medium mr-1 ${isPriceChanged(licenseTypePrice, origModelPrice) ? "text-green-600" : "text-gray-500"}`}
                          >
                            $
                          </span>
                          <span
                            className={`text-xs font-medium ${isPriceChanged(licenseTypePrice, origModelPrice) ? "text-green-600" : "text-gray-800"}`}
                          >
                            {licenseTypePrice.toFixed(2)}
                          </span>
                        </span>
                      }
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Door"
                      name="Type"
                      disabled={type === "info"}
                      type="number"
                      integerOnly
                      required
                      loading={loading}
                      prefix={<DoorTypeIcon />}
                      onChange={handleDoorChange}
                      postfix={
                        <span className="flex items-center">
                          <span className="h-7 border-l border-gray-300 mr-2"></span>
                          <span
                            className={`text-xs font-medium mr-1 ${isPriceChanged(doorPrice, origDoorPrice) ? "text-green-600" : "text-gray-500"}`}
                          >
                            $
                          </span>
                          <span
                            className={`text-xs font-medium ${isPriceChanged(doorPrice, origDoorPrice) ? "text-green-600" : "text-gray-800"}`}
                          >
                            {doorPrice.toFixed(2)}
                          </span>
                        </span>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Door is required",
                        },
                        {
                          validator: (_, value) => {
                            if (value && value > 65535) {
                              return Promise.reject(
                                new Error(
                                  "Door must be less than or equal to 65535!",
                                ),
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                  </Col>
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="OEM"
                    name="OemNo"
                    options={modifiedOems}
                    placeholder="Please select"
                    // value={form.getFieldValue("OemNo")}
                    disabled={type === "info"}
                    required
                    onChange={(value) => {
                      setOemNo(value);
                      setDealerNo(null);
                      form.setFieldsValue({
                        DealerNo: null,
                        CustomerNo: null,
                      });
                    }}
                  />
                </Col> */}
                </Row>
                {/* <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Type"
                    name="Type"
                    type="number"
                    disabled={type === "info"}
                    required
                  />
                </Col>
              
              </Row> */}
              </div>
            </div>
            <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <SettingOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  License Options
                </span>
              </div>
              <div className="px-2 py-3 grid gap-4">
                <OptionCards
                  name="Options"
                  options={modifiedOp}
                  disabled={type === "info"}
                  loading={loading || codesDataLoading}
                  codesData={codesData}
                  type={licenseType}
                  value={licenseOptionsData}
                  onChange={setLicenseOptionsData}
                />
                {/* <Row gutter={[16, 16]} className="p-2"> */}
                {/* <CustomCheckbox
                label=""
                name="Options"
                options={modifiedOp}
                disabled={type === "info"}
              /> */}
                {/* {modifiedOp?.length > 0 && (
                <SingleSelectCheckboxGroup
                  options={modifiedOp}
                  type={
                    type === "edit"
                      ? userData?.role_value >= 10
                        ? "info"
                        : "edit"
                      : type
                  }
                  name="Options"
                  onChange={(vals) => setSelectedValues(vals)}
                  defaultOptionsValue={selectedValues}
                  staticOptions={defaultOptionsValue}
                  disabled={type === "info" || userData?.role_value >= 10}
                />
              )} */}

                {/* </Row> */}
              </div>
            </div>
          </div>
          {type === "info" && data?.data?.Guest ? (
            <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5 ">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Customer Information
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="First Name"
                      name="FirstName"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Last Name"
                      name="LastName"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Installing Company"
                      name="Company"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Email"
                      name="Email"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Phone"
                      name="Phone"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Address"
                      name="Address2"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Install Type"
                      name="InstallType"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Suggestion"
                      name="Suggestion"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}
          {/* {type === "info" && (
            <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5 ">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Device Status
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Proxy Server"
                      name="ProxyNo"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Secure Port"
                      name="SecurePort"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Debug Port"
                      name="DebugPort"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Version"
                      name="Version"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Timeout"
                      name="Timeout"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Debug"
                      name="Debug"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Address"
                      name="Address"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="HTTPS"
                      name="Https"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Timezone"
                      name="Timezone"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Online"
                      name="Online"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )} */}
        </Form>
        {type === "info" && isSystemUser && (
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="bg-gray-200">
              <div className="py-[5.748px] px-2.5 custom-segmented">
                <Segmented
                  options={deviceTabs}
                  size="middle"
                  onChange={(value) => {
                    setTabValue(value);
                  }}
                  // defaultValue={deviceTabs[0].value}
                  className="!bg-transparent !text-black"
                />
              </div>
              {tabValue === "deviceLog" ? (
                <GlobalTable
                  columns={DeviceLogItemColumns()}
                  dataSource={deviceLogData?.data}
                  loading={deviceLogLoading}
                />
              ) : (
                <GlobalTable
                  columns={DeviceOrderItemColumns()}
                  dataSource={deviceLogOrderData?.data?.map((el) => ({
                    ...el,
                    key: el.OrderNo,
                  }))}
                  loading={deviceLogOrderLoading}
                  expandable={{
                    expandedRowKeys: orderExpandedRowKeys,
                    rowExpandable: (record) =>
                      Array.isArray(record?.OrderItems) &&
                      record.OrderItems.length > 0,
                    expandedRowRender: (record) => (
                      <div className="pl-8 pr-2 py-1">
                        <GlobalTable
                          columns={DeviceOrderItemChildColumns}
                          dataSource={record.OrderItems.map((item) => ({
                            ...item,
                            key: item.ItemNo,
                          }))}
                          pagination={false}
                          tableProps={{ size: "small" }}
                        />
                      </div>
                    ),
                    onExpand: (expanded, record) => {
                      if (expanded) {
                        setOrderExpandedRowKeys((prev) => [
                          ...prev,
                          record.OrderNo,
                        ]);
                      } else {
                        setOrderExpandedRowKeys((prev) =>
                          prev.filter((k) => k !== record.OrderNo),
                        );
                      }
                    },
                    columnWidth: 40,
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>

      <Modal
        open={showSummaryModal}
        onCancel={() => setShowSummaryModal(false)}
        closeIcon={false}
        footer={null}
        width={820}
        centered
        motion={false}
        destroyOnClose={true}
      >
        <LicenseConfirmForm
          onConfirm={handleConfirmSubmit}
          onCancel={() => setShowSummaryModal(false)}
          mergedData={pendingFormData}
          optionsData={licenseOptionsData}
          licenseType={licenseType}
          siteTypePrice={siteTypePrice}
          modelsOptions={modifiedModelsOptions}
          siteTypeOptions={modifiedSiteTypeOptions}
          setLicenseType={setLicenseType}
          licenseTypePrice={licenseTypePrice}
          doorPrice={doorPrice}
          form={form}
          loading={postLoading || putLoading}
          disableSelect
          edit={id && type === "edit"}
          originalLicenseData={originalLicenseData}
          dealerDiscountPercent={summaryDealerDiscountPercent}
        />
      </Modal>

      <Modal
        open={showCardsModal}
        onCancel={() => {
          setShowCardsModal(false);
          setCardsModalDealerNo(null);
        }}
        closeIcon={false}
        footer={null}
        width={520}
        centered
        motion={false}
        destroyOnClose
      >
        <ManageCardsModal
          setIsModalOpen={(open) => {
            setShowCardsModal(!!open);
            if (!open) setCardsModalDealerNo(null);
          }}
          dealerNo={cardsModalDealerNo}
          requiredMessage={AUTOBILLING_CARD_REQUIRED_MESSAGE}
        />
      </Modal>

      <Modal
        title={
          <div className="flex items-center justify-between bg-gray-200 p-2.5 rounded-md">
            <div className="flex items-center">
              <PaymentIcon className="text-[18px] text-black " />
              <span className="text-[14px] font-[Poppins] text-black ml-2">
                Make Payment
              </span>
            </div>
          </div>
        }
        open={paymentModal}
        onCancel={() => {
          setPaymentModal(false);
          // Admin: manual only; dealer: card only (see PaymentForm showCardLayout)
          setShowCardLayout(!isSystemUser);
          setPendingUpdatePayload(null);
          setPendingSubmitMode(null);
          setPriceChangeAmount(0);
          setLimitedLicenseSummary(null);
          selectedLimitedCardRef.current = null;
        }}
        footer={null}
        closeIcon={false}
        width={560}
        centered
        destroyOnClose
      >
        <MyPaymentForm
          DealerNo={
            data?.data?.DealerNo
              ? data?.data?.DealerNo
              : hasRole(7, 8, 9)
                ? userData?.dealer_no
                : dealerNo
          }
          amount={`$${Number(priceChangeAmount || 0).toFixed(2)}`}
          setPaymentModal={setPaymentModal}
          InvoiceNo={id}
          OrderName={data?.data?.DeviceName}
          refetch={() => {}}
          showCardLayout={showCardLayout}
          setShowCardLayout={setShowCardLayout}
          billingType={
            getDealerMeta(
              data?.data?.DealerNo
                ? data?.data?.DealerNo
                : hasRole(7, 8, 9)
                  ? userData?.dealer_no
                  : dealerNo,
            ).billingType
          }
          licensePeriod={
            pendingUpdatePayload?.LicenseType ??
            licenseType ??
            form.getFieldValue("LicenseType") ??
            0
          }
          beforePayment={async () => {
            // Limited License: charge first, then create order + update Intercom
            if (pendingSubmitMode === "limited") {
              if (!pendingUpdatePayload) return false;
              paymentFlowInProgressRef.current = true;
              return true;
            }
            if (!pendingUpdatePayload || !pendingSubmitMode) return false;
            paymentFlowInProgressRef.current = true;
            const payload = pendingUpdatePayload;
            const mode = pendingSubmitMode;
            try {
              const result =
                mode === "create"
                  ? await postAction(payload)
                  : await putAction(payload);
              if (!result) {
                paymentFlowInProgressRef.current = false;
                return false;
              }
              return true;
            } catch (e) {
              paymentFlowInProgressRef.current = false;
              return false;
            }
          }}
          onPaymentSuccess={async (paymentResponse) => {
            paymentFlowInProgressRef.current = false;
            if (!pendingUpdatePayload) return;

            const mode = pendingSubmitMode;
            const pending = pendingUpdatePayload;
            const limitedCard = selectedLimitedCardRef.current;

            if (mode === "limited") {
              const paymentNo =
                paymentResponse?.data?.PaymentNo ??
                paymentResponse?.PaymentNo ??
                paymentResponse?.data?.data?.PaymentNo ??
                null;
              const deviceNo =
                data?.data?.DeviceNo ??
                (id != null && id !== "" ? Number(id) : null);
              const amount = Number(
                pending?.Amount ?? pending?.Price ?? priceChangeAmount ?? 0,
              );
              const payback =
                pending?.Payback != null && pending?.Payback !== ""
                  ? Number(pending.Payback)
                  : null;
              const price = Number(pending?.Price);
              const limitedCardNo =
                pending?.LimitedCardNo ?? limitedCard?.LimitedCardNo ?? null;
              const licenseCode = Number(
                pending?.LicenseCode ?? limitedCard?.LicenseCode,
              );

              if (!paymentNo) {
                openErrorNotification(
                  "Payment succeeded but PaymentNo is missing.",
                );
                throw new Error("PaymentNo is missing");
              }
              if (deviceNo == null || Number.isNaN(Number(deviceNo))) {
                openErrorNotification("Device is not available.");
                throw new Error("DeviceNo is missing");
              }
              if (limitedCardNo == null) {
                openErrorNotification("Limited card is not available.");
                throw new Error("LimitedCardNo is missing");
              }
              if (!Number.isFinite(licenseCode) || licenseCode < 0) {
                openErrorNotification(
                  "Selected limited card has no valid License Code.",
                );
                throw new Error("LicenseCode is missing");
              }

              const orderPayload = {
                PaymentNo: paymentNo,
                DeviceNo: Number(deviceNo),
                Amount: Number.isFinite(amount) ? amount : 0,
                LimitedCardNo: limitedCardNo,
              };
              if (Number.isFinite(price) && price >= 0) {
                orderPayload.Price = price;
              }
              if (Number.isFinite(payback) && payback > 0) {
                orderPayload.Payback = payback;
              }

              const orderResult = await limitedOrderPostAction(orderPayload);

              if (!orderResult) {
                openErrorNotification(
                  "Payment succeeded but limited order failed.",
                );
                throw new Error("Limited order failed");
              }

              const applied = await applyLimitedLicenseIntercomUpdate(
                licenseCode,
                pending?.Price ?? amount,
              );
              if (!applied) {
                throw new Error("Device Intercom update failed");
              }
            }

            setPendingUpdatePayload(null);
            setPendingSubmitMode(null);
            setPriceChangeAmount(0);
            setLimitedLicenseSummary(null);
            selectedLimitedCardRef.current = null;
            // Navigate after the user closes the payment-success modal
            return () => {
              if (id) {
                navigate(`/device/info/${id}`);
              } else {
                navigate(-1);
              }
            };
          }}
        />
      </Modal>

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </div>
  );
};
